<template>
  <RF-Dialog
    :cpntStatus='statusGeral'
    :cpntLargura='"380px"'
    :cpntOnFecharDialog='conBuscaFechar'>
    <template slot='titulo'>
      <!-- SETA O ICONE -->
      <svg aria-hidden="true" class="fa fa-angle-double-right"></svg>

      <!-- SETA O TITULO DA ABA -->
      <span v-html="cpntTitulo"></span>

      <!-- SETA A PERGUNTINHA DE EXPLICAÇÃO -->
      <App-Explica v-if="[ '', null, undefined ].indexOf(cpntTituloExplica) === -1"
      :cpntTitle='cpntTituloExplica.mensagem'
      :cpntPositionMy='cpntTituloExplica.posicaoMy'
      :cpntPositionAt='cpntTituloExplica.posicaoAt'
      :cpntClasses='cpntTituloExplica.class'
      ></App-Explica>
    </template>

    <template slot='conteudo'>
      <div class="app-con-busca">
        <App-Autocompletar :data-time="time" :class="campos.busca.id"
          :cpntStatus='campos.busca.status'
          :cpntId='campos.busca.id'
          :cpntTabIndex='campos.busca.tabIndex'
          :cpntNome='campos.busca.nome'
          :cpntValue='campos.busca.value'
          :cpntMensagem='campos.busca.mensagem'
          :cpntMensagemTipo='campos.busca.mensagemTipo'
          :cpntDisabled='campos.busca.disabled'
          :cpntMostrar='campos.busca.mostrar === true'
          :cpntExplica='campos.busca.explica'
          :cpntPlaceholder='campos.busca.placeholder'
          :cpntValueRef='campos.busca.valueRef'
          :cpntRouter='campos.busca.router'
          :cpntMethod='campos.busca.method'
          :cpntField='campos.busca.field'
          :cpntWhere='campos.busca.where'
          :cpntAddButForm='campos.busca.addButForm'
          :cpntKeyMostra='campos.busca.keyMostra'
          :cpntTipoOrder='campos.busca.tipoOrder'
          :cpntOrder='campos.busca.order'
          :cpntOptions='campos.busca.options'
          :cpntKeyValue='campos.busca.keyValue'
          :cpntSearchMinimo='campos.busca.searchMinimo'
          :cpntMask='campos.busca.mask'
          :cpntNewOption='campos.busca.newOption'

          :cpntOnBuscarOptions='campos.busca.onBuscarOptions'
          :cpntOnChange='campos.busca.onChange'
          :cpntOnBlur='campos.busca.onBlur'
          :cpntOnRealizaBusca='campos.busca.onRealizaBusca'
          :cpntOnKeyPressEnter='campos.busca.onKeyPressEnter'
          ref="busca"
        ></App-Autocompletar>
      </div>
    </template>
  </RF-Dialog>
</template>

<style scoped>
.app-con-busca {
  margin-top: 15px;
}
</style>

<style>
</style>

<script>
  export default {
    props: {
      cpntTitulo: {
        required: true,
        default: function () {
          return 'Consultar Contato <b>[ALT+C]</b>'
        }
      },
      cpntTituloExplica: {
        required: false,
        default: function () {
          return null
        }
      },
      cpntSelecionar: {
        required: false,
        type: Boolean,
        default: function () {
          return false
        }
      },
      cpntFecharFormulario: {
        required: true
      }
    },
    components: {
      'App-Explica': () => import('@/components/rf-geral/explica/RF-Explica.vue')
    },
    data: function () {
      return {
        time: '',
        statusGeral: 'carregando',
        campos: {
          busca: {
            id: 'con-busca--busca',
            status: '',
            newOption: {
              tipo: 'icone',
              icone: { tipo: 'ico-mais' },
              explica: { titulo: '', mensagem: 'Adicionar novo contato' },
              class: [ 'btn', 'btn-primary', 'btn-sm' ],
              onClick: (string) => { this.conBuscaOnAbrirCartaoContato(string) }
            },
            nome: 'Buscar contato',
            router: '/contato/get',
            method: 'POST',
            field: { id: null, nome: null, empresa: null, cnpj_cpf: null },
            where: { aAnd: [ { f: 'status', o: '=', v: '1' }, { m: 'contato', o: 's.ft', v: '#BUSCA#' } ] },
            keyValue: 'id',
            keyMostra: [ 'nome', ' | ', 'empresa', ' | ', 'cnpj_cpf' ],
            disabled: false,
            mostrar: true,
            value: '',
            mensagem: '',
            mensagemTipo: '',
            onChange: this.conBuscaOnChange,
            onRealizaBusca: (busca) => {
              // LIMPA O VALOR DO CAMPO SELECIONADO
              this.campos.busca.value = busca

              // LIMPA O VALOR DO CAMPO SELECIONADO
              this.campos.busca.valueRef = ''
            }
          }
        }
      }
    },
    mounted: function () {
      this.conBuscaIniciar()
    },
    methods: {
      conBuscaIniciar: function () {
        // SETA O FOCUS DA PAGINA
        this.conBuscaSetarStatusGeral('')

        // SETA O FOCUS NO CAMPO
        this.conBuscaRealizarFocusCampo('busca')
      },
      conBuscaSetarStatusGeral: function (status) {
        // SETA O STATUS DA TELA
        this.statusGeral = status

        // SETA O TIME PARA FORÇAR O CARREGAMENTO DOS COMPONENTS
        this.time = new Date().getTime()
      },
      conBuscaFechar: function (atualizar = false, id = null, dados = null) {
        if (this.cpntSelecionar === true && atualizar === true && id !== null && dados === null) {
          // SETA O QUERY GET NA API
          var queryGet = { type: 'list', limit: { row: 0, qty: 1000 }, where: { f: 'id', o: '=', v: id } }

          // SETA OS CAMPOS QUE DEVE BUSCAR
          var campos = {
            id: null,
            nome: null,
            empresa: null,
            cnpj_cpf: null,
            ie: null,
            com_ind: null,
            rg: null,
            tel_res: null,
            tel_com: null,
            tel_cel: null,
            cargo: null,
            contato: null,
            email: null,
            email_ctr: null,
            site: null,
            cep: null,
            id_estado: { j: { estado: null } },
            id_cidade: { j: { cidade: null } },
            end: null,
            num: null,
            comp: null,
            bairro: null,
            aniv: null,
            id_tp_con: { j: { nome: null } },
            obs: null,
            pessoa: null,
            pj_sn: null,
            req: null,
            id_cms: null,
            pf_nacionalidade: null,
            pf_est_civil: null,
            pf_empresa: null,
            pf_profissao: null,
            status: null,
            updated_user: { j: { usuario: null } },
            updated_at: null
          }

          // SETA OS CAMPOS QUE DEVE BUSCAR
          queryGet.field = campos

          // COMUNICA COM A API
          this.$store.state.comunicaAPI('/contato/get', 'POST', queryGet, (retorno) => {            
            this.conBuscaFechar(true, id, retorno.data[0])
          }, this.conBuscaSetarStatusGeral)
        } else {
          switch (this.cpntSelecionar) {
            case true:
              this.cpntFecharFormulario(atualizar, id, dados)
              break
            
            case false:
              if ([ '', null, undefined ].indexOf(id) === -1) {
                this.conBuscaOnAbrirCartaoContato('', id)
              } else {
                this.cpntFecharFormulario(false)
              }
              break
          }
        }
      },
      conBuscaOnChange: function (value, id) {
        // PEGA O NOME DO CAMPO QUE ESTÁ SENDO ALTERADO
        var indexF = id.split('--')[1]

        // SETA O VALOR RECEBIDO
        this.$set(this.campos[indexF], 'value', value)

        // LIMPA O CAMPO DE MENSAGEM DE ERRO
        this.$set(this.campos[indexF], 'mensagem', '')

        // LIMPA O CAMPO DE MENSAGEM DE ERRO
        this.$set(this.campos[indexF], 'class', '')

        // VERIFICA A AÇÃO DO CAMPO
        switch (indexF) {
          case 'busca':
            this.conBuscaFechar(true, value.id)
            break
        }
      },
      conBuscaOnAbrirCartaoContato: function (string, _id = 0) {
        // SETA OS PARAMETROS QUE SERÁ ENVIADO
        var params = { tipo: 'contato', id: _id, nome: string, editar: (_id === 0) }

        // SETA O CALLBACK QUE DEVE EXECUTAR
        if (_id !== 0) {
          params.callback = this.cpntFecharFormulario
        } else {
          params.callback = (atualizar, id, dados) => {
            if (atualizar === true) {
              this.conBuscaOnChange(dados, this.campos.busca.id)
            }
          }
        }

        // CHAMA A FUNÇÃO PARA INFORMAR QUE A ROTA FOI ATUALIZADA
        this.$store.commit('SET_ABRIR_CADASTRO_VET', params)
      },
      conBuscaRealizarFocusCampo: function (chave, tentativa = 0) {
        // SETA O FOCUS NO CAMPO
        if (this.$store.state.mobile === false && tentativa <= 10) {
          if ([ '', null, undefined ].indexOf(this.$refs[chave]) === -1 && [ '', null, undefined ].indexOf(this.$refs[chave].cpntRealizarFocus) === -1) {
            this.$refs[chave].cpntRealizarFocus()
          } else {
            setTimeout(() => { this.conBuscaRealizarFocusCampo(chave, (tentativa + 1)) }, 250)
          }
        }
      }
    }
  }
</script>
